import Vue from 'vue'
import axios from 'axios'
import request from './request'

export default class FilesApi {

  async getHeaders(type) {
    const token = await Vue.prototype.$auth.getUserToken()
    const headers = {
      'Content-Type': type || 'multipart/form-data',
      'Authorization': `Bearer ${token ? token : ''}`,
      'Auth-Provider': 'SmartId',
      'OrganizationItId': sessionStorage.getItem('OrganizationItId'),
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0',
      'Access-Control-Allow-Headers': '*',
      'Access-Control-Allow-Origin': '*',
      'culture': sessionStorage.language,
      'accept-language': sessionStorage.language,
      'href': window.location.href,
    }
    if (crypto?.randomUUID)  {
      headers.correlationId = crypto.randomUUID()
    }
    const user = (await Vue.prototype.$auth.getUser())
    let my_local = localStorage.getObject(`${(user.profile.preferred_username || '').toLowerCase()}_settings`),
      GodMode = my_local && my_local.GodMode
    if (GodMode) {
      headers.GodMode = +GodMode
    }
    return headers
  }
  async uploadXlsToCart(file, listener) {
    const uri = window.config.GrapgQlUrl + '/files/xlsImport'

    let formData = new FormData()
    formData.append('file', file, encodeURI(file.name))
    return axios.post(uri, formData,
      {
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    )
  }
  async downloadXlsTemplate(listener) {
    const uri = window.config.GrapgQlUrl + '/files/xlsTemplate'
    return axios.get(uri,
      {
        headers: await this.getHeaders(),
        onUploadProgress: listener,
        responseType: 'blob'
      }
    )
  }
  async uploadDocument(tenderId, document, listener) {
    const uri = window.config.GrapgQlUrl + '/files/uploadDocument'
    let formData = new FormData()
    formData.append('file', document, encodeURI(document.name))
    return axios.post(uri, formData,
      {
        params: {
          tenderId: tenderId,
        },
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }
  async uploadAdditionalDocument(tenderId, document, listener) {
    const uri = window.config.GrapgQlUrl + '/files/uploadAdditionalDocument'
    let formData = new FormData()
    formData.append('file', document, encodeURI(document.name))
    return axios.post(uri, formData,
      {
        params: {
          tenderId: tenderId,
        },
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }
  async uploadPublicTenderResultDocument(tenderId, document, listener) {
    const uri = window.config.GrapgQlUrl + '/files/uploadPublicTenderResultDocument'
    let formData = new FormData()
    formData.append('file', document, encodeURI(document.name))
    return axios.post(uri, formData,
      {
        params: {
          tenderId: tenderId,
        },
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }
  async getDocument(tenderId, documentId, listener) {
    const uri = window.config.GrapgQlUrl + '/files/getDocument'
    return axios.get(uri,
      {
        params: {
          tenderId: tenderId,
          documentId: documentId,
        },
        headers: await this.getHeaders(),
        onDownloadProgress: listener,
        responseType: 'blob'
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }
  async changeAdditionalDocument(tenderId, fileId, document, listener) {
    return await this.execChangeDocument(tenderId, fileId, document, listener, '/files/changeAdditionalDocument')
  }
  async changePublicTenderResultDocument(tenderId, fileId, document, listener) {
    return await this.execChangeDocument(tenderId, fileId, document, listener, '/files/changePublicTenderResultDocument')
  }
  async changeStatusDocument(model) {
    return await request( {
      environment: '/tenders',
      type: 'mutation',
      variables: {model},
      name: 'changeStatusDocument',
      way: './graphql/smarttender/mutations/'
    } )
  }

  async deleteAdditionalDocument(tenderId, documentId, listener) {
    return await this.execDeleteDocument(tenderId, documentId, listener, '/files/deleteAdditionalDocument')
  }
  async deletePublicTenderResultDocument(tenderId, documentId, listener) {
    return await this.execDeleteDocument(tenderId, documentId, listener, '/files/deletePublicTenderResultDocument')
  }


  async execDeleteDocument(tenderId, documentId, listener, href = '/files/deleteDocument') {
    const uri = window.config.GrapgQlUrl + href
    return axios.delete(uri,
      {
        params: {
          tenderId: tenderId,
          documentId: documentId,
        },
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!! deleteDocument tenderId', res)
    })
  }

  async execChangeDocument(tenderId, fileId, document, listener, href = '/files/changeDocument') {
    const uri = window.config.GrapgQlUrl + href
    let formData = new FormData()
    formData.append('file', document, encodeURI(document.name))
    return axios.patch(uri, formData,
      {
        params: {
          tenderId: tenderId,
          fileId: fileId,
        },
        headers: await this.getHeaders(),
        onDownloadProgress: listener,
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }

  async changeDocument(tenderId, fileId, document, listener) {
    return await this.execChangeDocument(tenderId, fileId, document, listener)
  }

  async deleteDocument(tenderId, documentId, listener) {
    return await this.execDeleteDocument(tenderId, documentId, listener)
  }

  async addTaskAttachment(taskId, filename, file, listener) {
    const uri = window.config.GrapgQlUrl + '/files/addTaskAttachment'
    let formData = new FormData()
    formData.append('file', file, encodeURI(file.name))
    return axios.post(uri, formData,
      {
        params: {
          taskId: taskId,
          fileName: filename,
        },
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
    })
  }
  async getFileList(entityId, storageType) {
    return axios.get(`${window.config.GrapgQlUrl}/document`,
      {
        headers: await this.getHeaders(),
        params: {
          entityId: entityId,
          storageType: storageType
        },
      })
      .then((res) => {
        Vue.prototype.$log('SUCCESS!!', res)
        return res.data
      })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async deleteStorageDocument(entityId, fileId, storageType, listener) {
    const uri = window.config.GrapgQlUrl + '/document'
    return axios.delete(uri,
      {
        params: {
          entityId,
          fileId,
          storageType
        },
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!! deleteDocument tenderId', res)
    })
  }
  async uploadStorageDocument(entityId, document, storageType, listener) {
    const uri = window.config.GrapgQlUrl + '/document'

    let formData = new FormData()
    formData.append('file', document)
    return axios.post(uri, formData,
      {
        params: {
          entityId,
          storageType
        },
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    )
      .then((res) => {
        if (res?.data?.success) {
          Vue.prototype.$log('SUCCESS!!', res)
          return res.data.fileId
        } else {
          Vue.prototype.$log_error(res?.data?.message)
          return null
        }
      })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
      })
  }
  async geStorageDocument(documentId, listener) {
    const uri = documentId ? window.config.GrapgQlUrl + `/document/${documentId}` : null

    return axios.get(uri,
      {
        headers: await this.getHeaders(),
        onDownloadProgress: listener,
        responseType: 'blob'
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }

  async uploadStopDocument(id, document, listener) {
    const uri = window.config.GrapgQlUrl + '/files/stopList/uploadDocument'
    let formData = new FormData()
    formData.append('file', document, encodeURI(document.name))
    return axios.post(uri, formData,
      {
        params: {
          stopListID: id,
        },
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
    })
  }
  async downloadStopDocument(id,documentId, listener) {
    const uri = window.config.GrapgQlUrl + '/files/stopList/downloadDocument'
    return axios.get(uri,
      {
        params: {
          stopListID: id,
          documentId: documentId,
        },
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
    })
  }
  /**
   * скачування документу, не перевіряється доступ
   * @param {string} key
   * @param {function} listener
   * @returns
   */
  async downloadDocument(key, listener) {
    const uri = `${window.config?.SmarttenderUrl}Attachment/DownloadAttachmentByKey/${key}`
    return axios.get(uri,
      {
        headers: await this.getHeaders(),
        onUploadProgress: listener,
        responseType: 'blob'
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }

  async uploadGroupAccreditationDocument(optional , document, listener) {
    const uri = window.config.GrapgQlUrl + '/files/groupOfAccreditations/uploadDocument'
    let formData = new FormData()
    formData.append('file', document, encodeURI(document.name))
    return axios.post(uri, formData,
      {
        params: {
          groupId: optional.groupId,
        },
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
    })
  }


  async uploadQuestionDocument(optional , document, listener) {
    const uri = window.config.GrapgQlUrl + '/files/questions/uploadDocument'
    let formData = new FormData()
    formData.append('file', document, encodeURI(document.name))
    return axios.post(uri, formData,
      {
        params: {
          tenderId: optional.tenderId,
          questionId: optional.questionId
        },
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
    })
  }

  //   xlsTender?withLots=true body: {

  //     search: параметры поиска
  //  }
  async downloadXlsTenders(search, withLots, listener) {
    const uri = window.config.GrapgQlUrl + '/files/xlsTender?withLots=' + withLots
    return axios.post(uri,
      {search},
      {
        headers: await this.getHeaders('application/json'),
        onUploadProgress: listener,
        responseType: 'blob'
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }

  async getLotImportTemplate(uri, listener) {
    return axios.get(uri,
      {
        headers: await this.getHeaders(),
        onDownloadProgress: listener,
        responseType: 'blob'
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    }).catch((error) => {
      Vue.prototype.$log('Error:', error)
    })
  }

  /**
   * Универсальный импорт лотов через GraphQL upload
   * @param {Object} options
   * @param {File} options.file
   * @param {number|string} options.tenderId
   * @param {string} options.mutationName
   * @param {string} options.gqlFields
   * @returns {Promise}
   */
  async uploadLotsGeneric({ file, tenderId, mutationName, gqlFields }) {
    let formData = new FormData()
    const operations = JSON.stringify({
      query: `mutation( $xlsFile: Upload){${mutationName}(xlsFile: $xlsFile, tenderId: ${tenderId})${gqlFields.replace(/\n/g, ' ').replace(/\s{2,}/g, ' ')}}`,
      variables: { xlsFile: null },
      operationName: null
    })

    formData.append('operations', operations)
    formData.append('map', '{"0": ["variables.xlsFile"]}')
    formData.append('0', file)
    const uri = window.config.GrapgQlUrl + '/tenders'
    return axios.post(uri, formData, {
      headers: await this.getHeaders(),
    }).then(res => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }

  async uploadLotsWithAdditional(file, tenderId) {
    const gqlFields = (await import('./graphql/tenders/importLots/editTenderDraftWithImportLots.js')).default
    return this.uploadLotsGeneric({
      file,
      tenderId,
      mutationName: 'editTenderDraftWithImportLots',
      gqlFields
    })
  }

  async uploadLotsWithGroup(file, tenderId) {
    const gqlFields = (await import('./graphql/tenders/importLots/editTenderDraftWithImportLots.js')).default
    return this.uploadLotsGeneric({
      file,
      tenderId,
      mutationName: 'editTenderDraftWithImportLotsWithGroup',
      gqlFields
    })
  }

  async uploadMultiStageLotsWithAdditional(file, tenderId) {
    const gqlFields = (await import('./graphql/tenders/importLots/editMultiStageTenderDraftWithImportLots.js')).default
    return this.uploadLotsGeneric({
      file,
      tenderId,
      mutationName: 'editMultiStageTenderDraftWithImportLots',
      gqlFields
    })
  }

  async downloadCommercialOffer(tenderId, listener) {
    const uri = window.config.GrapgQlUrl + '/files/commercialoffer/' + tenderId
    return axios.get(uri,
      {
        headers: await this.getHeaders(),
        onDownloadProgress: listener,
        responseType: 'blob'
      }
    ).then((res) => {
      // ,res.request.getResponseHeader('content-disposition'), res.request.getAllResponseHeaders()
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }

  async getSignyDocuments(fileId, listener) {
    const uri = window.config.GrapgQlUrl + `/files/signyDocuments/downloadDocument/${fileId}`
    return axios.get(uri,
      {
        headers: await this.getHeaders('application/json'),
        onDownloadProgress: listener,
        responseType: 'blob'
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }
  async getBidsHistory(tenderId, listener) {
    const uri = window.config.GrapgQlUrl + '/files/generateReport/bids'
    return axios.post(uri, tenderId,
      {
        headers: await this.getHeaders('application/json'),
        onDownloadProgress: listener,
        responseType: 'blob'
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }

  async addBidAttachment(file, listener) {
    Vue.prototype.$log('file, listener', file, listener)
    const uri = window.config.GrapgQlUrl + '/files/addBidAttachment'
    let formData = new FormData()
    formData.append('file', file, encodeURI(file.name))
    return await axios.post(uri, formData,
      {
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }
  /**
   * Загрузка файла в КП
   */
  async addComercialOferDocument(tenderId, file, listener) {
    Vue.prototype.$log('file commercial offer, listener', tenderId, file, listener)
    const uri = window.config.GrapgQlUrl + `/files/${tenderId}/bidRequestImage`
    let formData = new FormData()
    formData.append('file', file, encodeURI(file.name))
    return await axios.post(uri, formData,
      {
        headers: await this.getHeaders(),
        onUploadProgress: listener
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }
  async deleteComercialOferDocument(tenderId, documentId, listener) {
    return await this.execDeleteDocument(tenderId, documentId, listener, `/files/${tenderId}/bidRequestImage/${documentId}`)
  }
  async getTenderProtocol(subpath, listener) {
    const uri = window.config.GrapgQlUrl + '/files/getGeneratedTenderReport/' + subpath
    return axios.get(uri,
      {
        headers: await this.getHeaders(),
        onDownloadProgress: listener,
        responseType: 'blob'
      }
    ).then((res) => {
      Vue.prototype.$log('SUCCESS!!', res)
      return res
    })
  }

}
